const KeenSlider = window.KeenSlider
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class PairItWith extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.selectors = {
      slider: '.keen-slider',
      slides: '.keen-slider__slide',
    }
  }

  setupListeners () {
    super.setupListeners()

    this.observer = new MutationObserver((mutations, observer) => {
      const slide = this.querySelector(this.selectors.slides)

      if (!slide) {
        return
      }

      this.classList.remove('sec-Section-hidden')

      window.requestAnimationFrame(() => {
        this.setupCarousel()
      })
    })

    this.observer.observe(this, {
      childList: true,
      subtree: true,
    })

    if (this.querySelector(this.selectors.slides)) {
      this.classList.remove('sec-Section-hidden')
      window.requestAnimationFrame(() => {
        this.setupCarousel()
      })
    }

    const productId = this.dataset.productId
    if (productId) {
      this.fetchRecommendations(productId)
    }
  }

  async fetchRecommendations (productId) {
    try {
      const rootUrl =
        window.routes?.root_url?.length > 1 ? window.routes.root_url : ''
      const url = `${rootUrl}/recommendations/products?product_id=${productId}&limit=10&section_id=pair-it-with-recommendations&intent=related`

      const response = await fetch(url)

      if (!response.ok) {
        console.warn(
          `Pair it with recommendations: request failed (${response.status})`,
          url,
        )
        return
      }

      const text = await response.text()
      const html = document.createElement('div')
      html.innerHTML = text

      const products = html.querySelector('.piw-PairItWith_Products')

      if (!products) {
        console.warn(
          'Pair it with recommendations: no products returned for product',
          productId,
        )
        return
      }

      const slideCount = products.querySelectorAll(this.selectors.slides).length

      if (slideCount === 0) {
        console.warn(
          'Pair it with recommendations: section rendered but contained no slides',
        )
        return
      }

      const carousel = this.querySelector('.piw-PairItWith_Carousel')
      if (carousel) {
        carousel.appendChild(products)
      }
    } catch (err) {
      console.error('Pair it with recommendations failed to load', err.message)
    }
  }

  setupCarousel () {
    try {
      return new KeenSlider(
        this.querySelector(this.selectors.slider),
        {
          selector: this.selectors.slides,
          loop: false,
          mode: 'snap',
          rubberband: false,
          slides: {
            perView: 3.2,
            spacing: 10,
          },
          breakpoints: {
            '(min-width: 901px)': {
              slides: {
                perView: 3,
                spacing: 10,
              },
            },
          },
        },
        [
          setInitialised(),
          useArrows({
            container: this.els?.arrows?.element,
            next: this.els?.next?.element,
            previous: this.els?.previous?.element,
          }),
        ],
      )
    } catch (err) {
      console.error('Pair it with carousel failed to initialise', err.message)
    }
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.observer.disconnect()
  }
}

if (!customElements.get('pair-it-with')) {
  customElements.define('pair-it-with', PairItWith)
}
